import { IWorkflowExecution } from '../models/workflows.models';

// ── Execution redirect targets ───────────────────────────────────────────────
// Where a history / last-run entry links to: its order (order-created
// automations) or its inbox thread. Shared by the history table and the
// builder preview's "Last runs" list.

const ORDER_DETAIL_URL = '/quotations/';
const SMART_INBOX_THREAD_URL = '/smart-inbox?include_thread_ids=';

/** Redirect URL for an execution, or null when it references neither an order nor a thread. */
export function executionTargetUrl(execution: IWorkflowExecution): string | null {
  if (execution.order) {
    return `${ORDER_DETAIL_URL}${execution.order.id}`;
  }
  if (execution.thread) {
    return `${SMART_INBOX_THREAD_URL}${execution.thread.id}`;
  }
  return null;
}

/** Human-readable label for the execution's redirect target. */
export function executionTargetLabel(execution: IWorkflowExecution): string {
  if (execution.order) {
    return execution.order.name || `#${execution.order.id}`;
  }
  return execution.thread?.subject ?? '';
}

/** Short reference shown on the right of a "Last runs" row (order ref or thread id). */
export function executionTargetRef(execution: IWorkflowExecution): string {
  if (execution.order) {
    return execution.order.name || `#${execution.order.id}`;
  }
  return execution.thread ? `${execution.thread.id}` : '';
}
